import { useResubscribeAdminNewsletterSubscriberMutation } from '@codezo/graphql';
import { useThemeColors } from '@codezo/theme';
import { Anchor, Box, Button, Paper, Stack, Text } from '@mantine/core';
import { IconCheck, IconMail } from '@tabler/icons-react';
import { useMemo, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { Logo } from '../components/common/Logo';

export function ResubscribePage() {
	const colors = useThemeColors();
	const [searchParams] = useSearchParams();
	const [done, setDone] = useState(false);

	const email = useMemo(() => {
		const raw = searchParams.get('email') || '';
		try {
			return atob(raw);
		} catch {
			return raw;
		}
	}, [searchParams]);

	const [resubscribe, { loading }] = useResubscribeAdminNewsletterSubscriberMutation({
		onCompleted: () => setDone(true),
		onError: () => setDone(true),
	});

	const handleResubscribe = () => {
		if (!email) return;
		resubscribe({ variables: { email } });
	};

	const unsubscribeLink = `/unsubscribe?email=${searchParams.get('email') || ''}`;

	return (
		<Box
			style={{
				minHeight: '100vh',
				backgroundColor: colors.background,
				display: 'flex',
				alignItems: 'center',
				justifyContent: 'center',
				padding: '16px',
			}}
		>
			<Paper withBorder shadow="xs" p="xl" radius="md" w={420}>
				<Stack align="center" gap="md">
					<Logo height={28} />

					{done ? (
						<>
							<IconCheck size={48} stroke={1.5} />
							<Text size="lg" fw={600} ta="center">
								You have been resubscribed
							</Text>
							<Text size="sm" c="dimmed" ta="center">
								You will receive newsletter emails from us again.
							</Text>
							<Anchor component={Link} to={unsubscribeLink} size="sm">
								Changed your mind? Unsubscribe
							</Anchor>
						</>
					) : (
						<>
							<IconMail size={48} stroke={1.5} />
							<Text size="lg" fw={600} ta="center">
								Resubscribe to newsletter
							</Text>
							{email ? (
								<>
									<Text size="sm" c="dimmed" ta="center">
										Click the button below to resubscribe{' '}
										<Text span fw={500}>
											{email}
										</Text>{' '}
										to our newsletter.
									</Text>
									<Button
										color="dark"
										fullWidth
										onClick={handleResubscribe}
										loading={loading}
										mt="sm"
									>
										Resubscribe
									</Button>
								</>
							) : (
								<Text size="sm" c="dimmed" ta="center">
									Invalid resubscribe link. Please use the link from your email.
								</Text>
							)}
						</>
					)}
				</Stack>
			</Paper>
		</Box>
	);
}
